import React from "react";
import "./customTable.css";

const MERGE_KEYS = ["date", "particular"];

const isPrimitive = (v) =>
  v === null || ["string", "number", "boolean"].includes(typeof v);

const buildRowSpanMap = (rows, mergeKeys) => {
  const spanMap = {};
  let i = 0;

  while (i < rows.length) {
    let span = 1;

    for (
      let j = i + 1;
      j < rows.length &&
      mergeKeys.every((k) => rows[j][k] === rows[i][k]);
      j++
    ) {
      span++;
    }

    mergeKeys.forEach((key) => {
      spanMap[`${i}-${key}`] = span;
      for (let k = i + 1; k < i + span; k++) {
        spanMap[`${k}-${key}`] = 0;
      }
    });

    i += span;
  }

  return spanMap;
};


const FinancialTable = ({ rows }) => {
  if (!rows?.length) return null;

  const simpleColumns = Object.keys(rows[0]).filter(
    (key) =>
      !key.startsWith("_") &&
      key !== "companies" &&
      isPrimitive(rows[0][key])
  );

  const companies = rows[0].companies || [];

  const periods = Array.from(
    new Set(
      companies.flatMap((company) =>
        Object.keys(company).filter(
          (k) => k !== "title" && !k.startsWith("_")
        )
      )
    )
  );

  const rowSpanMap = buildRowSpanMap(rows, MERGE_KEYS);

  return (
    <div className="table-container">
      <table className="financial-table">
        <thead>
          <tr>
            {simpleColumns.map((col) => (
              <th key={col} className="col-text" rowSpan={2}>
                {col.toUpperCase()}
              </th>
            ))}

            {companies.map((company, idx) => (
              <th
                key={idx}
                className="col-group"
                colSpan={periods.length}
              >
                {company.title}
              </th>
            ))}
          </tr>

          <tr>
            {companies.map(() =>
              periods.map((p) => (
                <th key={p} className="col-number">
                  {p}
                </th>
              ))
            )}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row._id || rowIndex}>
              {simpleColumns.map((col) => {
                if (MERGE_KEYS.includes(col)) {
                  const span = rowSpanMap[`${rowIndex}-${col}`];
                  if (span === 0) return null;

                  return (
                    <td
                      key={col}
                      className="col-text"
                      rowSpan={span}
                    >
                      {row[col]}
                    </td>
                  );
                }

                return (
                  <td key={col} className="col-text">
                    {row[col]}
                  </td>
                );
              })}

              {row.companies.map((company, cIdx) =>
                periods.map((period) => (
                  <td
                    key={`${rowIndex}-${cIdx}-${period}`}
                    className="col-number"
                  >
                    {company[period] ?? ""}
                  </td>
                ))
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FinancialTable;
